module.exports = __webpack_public_path__ + "img/rutear_active.4a3f1407.svg";